import $ from "jquery";
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

$(document).on("turbolinks:load", () => {
  var today = new Date();
  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  var minDate = new Date(today.getFullYear() - 120, 0);
  var eighty_years_ago = new Date(today.getFullYear() - 80, 0);
  var customer_birthday_val = $(
    'input[data-toggle="flatpickr"]#customer-birthday'
  ).val();
  var customer_birthday_default = customer_birthday_val
    ? customer_birthday_val
    : (customer_birthday_default = eighty_years_ago);
  const customerDefaultOptions = {
    locale: Japanese,
    defaultDate: customer_birthday_default,
    minDate: minDate,
    maxDate: today,
    altFormat: "Y/m/d",
    allowInput: false,
    dateFormat: "Y/m/d",
    altInput: true,
  };
  flatpickr(
    'input[data-toggle="flatpickr"]#customer-birthday',
    customerDefaultOptions
  );

  var sixtyYearsAgo = new Date(today.getFullYear() - 60, 0);
  var customerFamilyVal = $(
    'input[data-toggle="flatpickr"]#customer-family-birthday'
  ).val();
  var customerFamilyDefault = customerFamilyVal ? customerFamilyVal : sixtyYearsAgo;
  const customerFamilyDefaultOptions = {
    locale: Japanese,
    defaultDate: customerFamilyDefault,
    minDate: minDate,
    maxDate: today,
    altFormat: "Y/m/d",
    allowInput: false,
    dateFormat: "Y/m/d",
    altInput: true,
  };
  flatpickr(
    'input[data-toggle="flatpickr"]#customer-family-birthday',
    customerFamilyDefaultOptions
  );

  var messageStartAtVal = $(
    'input[data-toggle="flatpickr"]#message_start_at'
  ).val();
  var messageEndAtVal = $(
    'input[data-toggle="flatpickr"]#message_end_at'
  ).val();
  var messageStartAtDefault = messageStartAtVal ? messageStartAtVal : today;
  var messageEndAtDefault = messageEndAtVal ? messageEndAtVal : tomorrow;
  const messageStartDefaultOptions = {
    locale: Japanese,
    defaultDate: messageStartAtDefault,
    enableTime: true,
    altFormat: "Y/m/d H:i",
    allowInput: false,
    dateFormat: "Y/m/d H:i",
    altInput: true,
  };
  const messageEndDefaultOptions = {
    locale: Japanese,
    defaultDate: messageEndAtDefault,
    enableTime: true,
    altFormat: "Y/m/d H:i",
    allowInput: false,
    dateFormat: "Y/m/d H:i",
    altInput: true,
  };
  flatpickr(
    'input[data-toggle="flatpickr"]#message_start_at',
    messageStartDefaultOptions
  );
  flatpickr(
    'input[data-toggle="flatpickr"]#message_end_at',
    messageEndDefaultOptions
  );

  // サービス時間設定
  var serviceOutageStartAtVal = $(
    'input[data-toggle="flatpickr"]#service_outage_start_at'
  ).val();
  var serviceOutageEndAtVal = $(
    'input[data-toggle="flatpickr"]#service_outage_end_at'
  ).val();
  var serviceOutageStartAtDefault = serviceOutageStartAtVal ? serviceOutageStartAtVal : today;
  var serviceOutageEndAtDefault = serviceOutageEndAtVal ? serviceOutageEndAtVal : tomorrow;
  const serviceOutageStartDefaultOptions = {
    locale: Japanese,
    defaultDate: serviceOutageStartAtDefault,
    enableTime: true,
    altFormat: "Y/m/d H:i",
    allowInput: false,
    dateFormat: "Y/m/d H:i",
    altInput: true,
  };
  const serviceOutageEndDefaultOptions = {
    locale: Japanese,
    defaultDate: serviceOutageEndAtDefault,
    enableTime: true,
    altFormat: "Y/m/d H:i",
    allowInput: false,
    dateFormat: "Y/m/d H:i",
    altInput: true,
  };
  flatpickr(
    'input[data-toggle="flatpickr"]#service_outage_start_at',
    serviceOutageStartDefaultOptions
  );
  flatpickr(
    'input[data-toggle="flatpickr"]#service_outage_end_at',
    serviceOutageEndDefaultOptions
  );

  // 定期配信詳細
  var inputCalendar = document.getElementById('regular-message-input-calendar');
  var hiddenSelectableDatesList = $(".hidden-selectable-dates-list input");

  console.log(inputCalendar)
  if (inputCalendar) {
    var arr = hiddenSelectableDatesList.map(function(){
      return $(this).val();
    }).get();
    var fp = flatpickr(inputCalendar, {
      dateFormat: 'Y-n-j', // フォーマットの変更
      onChange: function(selectedDates, dateStr, instance) {
        var regularMessageId = $('input.regular-message-id').val()
        window.location.href = `/admin/regular_messages/${regularMessageId}?provide_start_at=` + dateStr;
      },
      enable: [
        function(date) {
          // trueを返して無効化します。
          return (arr.includes(formatDate(date)));
        }
      ]
    });
  }

  function formatDate(dt) {
    var y = dt.getFullYear();
    var m = ('00' + (dt.getMonth()+1)).slice(-2);
    var d = ('00' + dt.getDate()).slice(-2);
    return (y + '-' + m + '-' + d);
  }

});
